import { Box, Flex } from '@radix-ui/themes'
import * as React from 'react'

import { BrandName } from '#app/components/common/brand-name'
import { AnimatedLogo } from '#app/components/common/logo'

/* -------------------------------------------------------------------------------------------------
 * Header
 * -----------------------------------------------------------------------------------------------*/

const Header: React.FC = () => {
	return (
		<Flex asChild direction="column" justify="center" align="center" gapY="3">
			<header>
				<AnimatedLogo width={152} height={152} />
				<Box
					width={{
						initial: '20em',
						xs: '24em',
						md: '28em',
						lg: '32em',
						xl: '37em',
					}}
					mt="5"
					p="6"
				>
					<BrandName />
				</Box>
			</header>
		</Flex>
	)
}
Header.displayName = 'Header'

/* -----------------------------------------------------------------------------------------------*/

export { Header }
